import AGREGAR_CATALOGO_ETIQUETA from '@/graphql/mutations/administracion/catalogos/etiquetas/agregarCatalogoEtiqueta.gql';
import ETIQUETAS from '@/graphql/querys/administracion/catalogos/etiquetas/etiquetas.gql';
import ATUALIZAR_CATALOGO_ETIQUETA from '@/graphql/mutations/administracion/catalogos/etiquetas/actualizarCatalogoEtiqueta.gql';
import REMOVER_CATALOGO_ETIQUETA from '@/graphql/mutations/administracion/catalogos/etiquetas/removerCatalogoEtiqueta.gql';

export default {
  methods: {
    async mixAgregarEtiqueta() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      await this.$apollo.mutate({
        mutation: AGREGAR_CATALOGO_ETIQUETA,
        variables: {
          etiqueta: this.etiqueta,
        },
        update: (store, { data: { agregarCatalogoEtiqueta } }) => {
          const data = store.readQuery({ query: ETIQUETAS });
          data.etiquetas.push(agregarCatalogoEtiqueta);
          store.writeQuery({ query: ETIQUETAS, data });
        },
      }).then(() => {
        this.mixMensajeSuccess();
      }).catch((err) => {
        this.mixMensajeError(err);
      });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },

    async mixActualizarEtiqueta() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      await this.$apollo.mutate({
        mutation: ATUALIZAR_CATALOGO_ETIQUETA,
        variables: {
          id: this.etiquetaEditar.id,
          etiqueta: this.etiqueta,
        },
        update: (store, { data: { actualizarCatalogoEtiqueta } }) => {
          const data = store.readQuery({ query: ETIQUETAS });
          const { etiquetas } = data;
          const index = etiquetas
            .findIndex((etiqueta) => etiqueta.id === actualizarCatalogoEtiqueta.id);
          if (index !== -1) {
            etiquetas.splice(index, 1, actualizarCatalogoEtiqueta);
          }
          store.writeQuery({ query: ETIQUETAS, data });
        },
      }).then(() => {
        this.mixMensajeSuccess();
      }).catch((err) => {
        this.mixMensajeError(err);
      });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },

    async mixEliminarEtiqueta() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      await this.$apollo.mutate({
        mutation: REMOVER_CATALOGO_ETIQUETA,
        variables: {
          id: this.etiquetaEliminar.id,
        },
        update: (store) => {
          const data = store.readQuery({ query: ETIQUETAS });
          const { etiquetas } = data;
          const index = etiquetas
            .findIndex((etiqueta) => etiqueta.id === this.etiquetaEliminar.id);
          if (index !== -1) {
            etiquetas.splice(index, 1);
          }
          store.writeQuery({ query: ETIQUETAS, data });
        },
      }).then(() => {
        this.mixMensajeSuccess();
      }).catch((err) => {
        this.mixMensajeError(err);
      });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
  },
};
